export const UPDATE_USER = 'auth/UPDATE_USER'
export const CLEAR_USER = 'auth/CLEAR_USER'



// WEBPACK FOOTER //
// ./src/vuex/modules/auth/types.js